<template>
	<div :class="['container__tag', classNameComputada]">
		<p style="margin: 0">
			{{ label }}
		</p>
		<i
			:class="buttonIcon"
			:disabled="disabled"
			@click.stop="closeButtonClick"
		/>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Icone do botao dentro da tag
		 */
		buttonIcon: { type: String, required: true, default: 'fas fa-times' },
		/**
		 * Classe que sera aplicada
		 */
		className: { type: [String, Array], default: () => ['default', 'outlined'] },
		/**
		 * Identificador da Tag para ser enviado quando clicar no botao
		 */
		identificadorDaTag: [String, Object],
		/**
		 * Legenda para a Tag
		 */
		label: { type: String, required: true },

		disabled: { type: Boolean },
	},
	computed: {
		classNameComputada() {
			return this.className instanceof Array
				? this.className.toString().split(',').join(' ')
				: this.className
		},
	},
	methods: {
		/**
		 * Dispara evento do botao fechar
		 */
		closeButtonClick() {
			if (!this.disabled) {
				this.$emit('clickEvent', this.identificadorDaTag)
			}
		},
	},
}
</script>

<style scoped src="../../css/tag.css"></style>
<style scoped>
.container__tag {
	cursor: pointer;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	padding-right: 0.3rem;
}

.container__tag i {
	font-size: 0.8rem;
	cursor: pointer;
	line-height: inherit;
}
.container__tag i.disabled {
	cursor: not-allowed;
	opacity: 0.5;
}

.container__tag i:hover {
	color: rgb(var(--color-default));
}
</style>
